import { FIELD_TYPES } from "base/constants";
const SORT_BY = {
  ASCENDING: "ASC",
  DESCENDING: "DESC"
};
export function sortData(props) {
  const {
    items,
    singleItem,
    fieldId,
    fieldType,
    sortingOrder,
    customSortBy // customSortBy = () => {}
  } = props;
  let itemsClone = [...items];
  if (singleItem) {
    let oldItems = [...items];
    itemsClone = itemsClone.filter((item) => item._id !== singleItem._id);
    for (let index = 0; index < itemsClone.length; index++) {
      let sortingFunction = customSortBy
        ? customSortBy
        : getSortingFunction(fieldType, fieldId, sortingOrder);
      let returnValue = sortingFunction(itemsClone[index], singleItem);
      if (returnValue >= 0) {
        itemsClone = itemsClone
          .slice(0, index)
          .concat(singleItem)
          .concat(itemsClone.slice(index));
        break;
      }
    }
    if (oldItems.length !== itemsClone.length) {
      if (sortingOrder === SORT_BY.ASCENDING) {
        itemsClone = [...itemsClone, singleItem];
      } else {
        itemsClone = [singleItem, ...itemsClone];
      }
    }
  } else {
    let sortingFunction = customSortBy
      ? customSortBy
      : getSortingFunction(fieldType, fieldId, sortingOrder);
    itemsClone.sort(sortingFunction);
  }
  return itemsClone;
}

function getSortingFunction(fieldType, fieldId, sortingOrder) {
  switch (fieldType) {
    case FIELD_TYPES.TEXT:
    case FIELD_TYPES.SELECT:
    case FIELD_TYPES.TEXT_AREA:
    case FIELD_TYPES.EMAIL:
    case FIELD_TYPES.BOOLEAN:
    case FIELD_TYPES.AGGREGATION:
      return (a, b) => {
        return sortByOrder(a[fieldId], b[fieldId], sortingOrder);
      };
    case FIELD_TYPES.NUMBER:
    case FIELD_TYPES.SLIDER:
    case FIELD_TYPES.STAR_RATING:
      return (a, b) => {
        return sortByOrder(a[fieldId], b[fieldId], sortingOrder);
      };
    case FIELD_TYPES.CURRENCY:
      return (a, b) => {
        const firstValue = a[fieldId]
          ? parseInt(a[fieldId].split(" ")[0], 10)
          : a[fieldId];
        const secondValue = b[fieldId]
          ? parseInt(b[fieldId].split(" ")[0], 10)
          : b[fieldId];
        return numericSortByOrder(firstValue, secondValue, sortingOrder);
      };
    case FIELD_TYPES.REFERENCE:
    case FIELD_TYPES.USER:
      return (a, b) => {
        const firstValue = a[fieldId] ? a[fieldId].Name : a[fieldId];
        const secondValue = b[fieldId] ? b[fieldId].Name : b[fieldId];
        return sortByOrder(firstValue, secondValue, sortingOrder);
      };
    case FIELD_TYPES.DATE_TIME:
      return (a, b) => {
        const firstValue = a[fieldId]
          ? new Date(a[fieldId].split(" ")[0]).getTime()
          : a[fieldId];
        const secondValue = b[fieldId]
          ? new Date(b[fieldId].split(" ")[0]).getTime()
          : b[fieldId];
        return numericSortByOrder(firstValue, secondValue, sortingOrder);
      };
    case FIELD_TYPES.DATE:
      return (a, b) => {
        const firstValue = a[fieldId]
          ? new Date(a[fieldId]).getTime()
          : a[fieldId];
        const secondValue = b[fieldId]
          ? new Date(b[fieldId]).getTime()
          : b[fieldId];
        return numericSortByOrder(firstValue, secondValue, sortingOrder);
      };
    default:
      break;
  }
}

function numericSortByOrder(firstValue, secondValue, sortingOrder) {
  const zeroValue = -0.000000001;
  firstValue = firstValue != null ? firstValue : zeroValue;
  secondValue = secondValue != null ? secondValue : zeroValue;

  if (sortingOrder === SORT_BY.ASCENDING) {
    return firstValue - secondValue;
  } else {
    return secondValue - firstValue;
  }
}

export function sortByOrder(firstValue = "", secondValue = "", sortingOrder) {
  if (sortingOrder === SORT_BY.ASCENDING) {
    if (firstValue === null) {
      return -1;
    } else if (secondValue === null) {
      return 1;
    } else if (firstValue === secondValue) {
      return 0;
    }
    return firstValue > secondValue ? 1 : -1;
  } else {
    if (firstValue === null) {
      return 1;
    } else if (secondValue === null) {
      return -1;
    } else if (firstValue === secondValue) {
      return 0;
    }
    return firstValue < secondValue ? 1 : -1;
  }
}
